<div class="main-nav-dashboard">
  <div class="container">
    <div class="row">
      <div class="column-12">
        <ul class="list-inline justify-content-between">
          <li><a class="main-nav-dashboard-link" href="https://www.odido.nl">Terug naar odido.nl</a></li>
          <li><a class="main-nav-dashboard-link" href="https://www.odido.nl/service">Naar Service</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>

<header class="glow-static py-6">
  <div class="container">
    <div class="row">
      <ng-container *ngTemplateOutlet="userheader"></ng-container>
      @if (loggedIn) {
        <div class="column-auto flex align-items-center">
          @if (account?.isAgent && agentCustomerCode) {
            <a class="navbar-link navbar-user hidden-tablet-down" (click)="logout()" title="{{ 'logout' | content}}">
              <span class="icon-service-employee mr-1"></span>
              <div>
                <span class="ml-1" data-hj-masked>{{ username }}</span>
                <span class="ml-1" data-hj-masked>{{ agentCustomerCode }}</span>
              </div>
            </a>
          }
          <div class="d-block">
            <div [ngClass]="account?.magentaSubscriptions?.length > 0 ? 'navbar-user' : 'no-pointer-events'" class="hidden-mobile-down">
              <ng-container *ngTemplateOutlet="thuisHeader"></ng-container>
            </div>
            @if (account?.isAgent) {
              <div class="hidden-mobile-down">
                @if (!agentCustomerCode) {
                  <span
                    class="text-weight-bold text-extra-small"
                    [innerHTML]="'close-tab-to-logout-text' | content"
                  ></span>
                }
              </div>
            }
            @if (account?.isAgent == false) {
              <div [ngClass]="account?.magentaSubscriptions?.length > 0 ? 'navbar-user' : 'no-pointer-events'" class="hidden-tablet-up" data-navbar-user>
                <ng-container *ngTemplateOutlet="thuisHeader"></ng-container>
              </div>
            }
            @if (account?.isAgent) {
              <div class="hidden-tablet-up" data-navbar-user>
                @if (agentCustomerCode) {
                  <a role="button" data-modal-toggle="#modal-user-menu" class="navbar-user">
                    <span class="icon-service-employee"></span>
                  </a>
                }
                @if (!agentCustomerCode) {
                  <span class="icon-service-employee"></span>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</header>

@if (account?.magentaSubscriptions?.length > 0) {
  <div class="modal fade" id="modal-user-menu" tabindex="-1" role="dialog" aria-labelledby="modal-user-menu" aria-hidden="true">
    <div class="modal-dialog modal-dialog-drawer modal-dialog-drawer-top">
      <div class="modal-content h-auto">
        <div class="modal-header justify-content-center">
          <h3 class="modal-title">Mijn abonnementen</h3>
          <button type="button" class="modal-close-button" data-modal-dismiss="" aria-label="Close"></button>
        </div>
        <div class="modal-body border-top py-5">
          <div class="container">
            <div class="row">
              <div class="column-12 column-desktop-large-8 mx-desktop-auto">
                <div class="row no-gutters w-100">
                  @if (loggedIn) {
                    <app-subscription-switcher
                      class="w-100"
                      [account]="account"
                      >
                    </app-subscription-switcher>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-top pb-6">
          <div class="container w-100">
            <div class="row">
              <div class="column-12 flex align-items-center">
                <div class="flex align-items-center">
                  @if (customerData?.customerInitials?.length === 2) {
                    <div class="avatar avatar-black mr-2">{{ customerData?.customerInitials }}</div>
                  }
                  @if (customerData) {
                    <a class="customer-data" [appTrackingNav]="'Mijn account'" [href]="magentaAccountUrl">Mijn account</a>
                  }
                </div>
                <div class="flex align-items-center ml-auto">
                  @if (account?.isAgent == false) {
                    <a class="navbar-link" (click)="logout()">
                      <span class="icon-logout icon-size-s"></span>
                      <span class="ml-1 is-underlined">{{ 'logout' | content}}</span>
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #userheader>
  <div class="column flex align-items-center">
    <div>
      <a class="customer-data" [appTrackingNav]="'Mijn account'" [href]="magentaAccountUrl">
        <span class="icon-chevron-left icon-size-s mr-2"></span>
        <ng-container *ngTemplateOutlet="userheadercontent"></ng-container>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #userheadercontent>
  <div class="avatar avatar-white mr-2" [ngClass]="{'hidden': canHideAvatar()}">{{ customerData?.customerInitials }}</div>
  @if (customerData) {
    <span class="text-transform-reset hidden-mobile-down customer-name">Mijn account</span>
  }
</ng-template>

<ng-template #thuisHeader>
  <div class="flex align-items-center ml-auto" style="position: relative" role="button" data-modal-toggle="#modal-user-menu">
    <img class="mr-3" [src]="iconSrc" style="max-width: 24px">
    <strong class="no-link-tel mr-2 alias">{{ account?.magentaAlias ? account.magentaAlias : productName$ | async }}</strong>
    @if (account?.magentaSubscriptions?.length > 0) {
      <span class="icon-chevron-down-solid"></span>
    }
    <button aria-label="Meerdere gelinkte abonnementen" class="button-link stretched-link" data-modal-toggle="#navbar-user-modal" type="button"></button>
  </div>
</ng-template>
